import React from 'react';
import { cns } from '../../utils';
import css from './Input.module.scss';

export interface InputProps {
    id?: string;
    icon?: React.ReactNode;
    multiline?: boolean;
    containerProps?: React.HTMLAttributes<HTMLDivElement>;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    textareaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
}

export const Input: React.FC<InputProps> = (props: InputProps) => {
    const containerProps = props.containerProps
        ? {
              ...props.containerProps,
              className: cns(props.containerProps.className, css.inputContainer),
          }
        : {
              className: css.inputContainer,
          };

    if (props.multiline) {
        const textareaProps = props.textareaProps
            ? {
                  id: props.id,
                  ...props.textareaProps,
                  className: cns(props.textareaProps.className, css.input),
              }
            : {
                  id: props.id,
                  className: css.input,
              };
        return (
            <div {...containerProps}>
                <textarea {...textareaProps} autoFocus />
                {props.icon}
            </div>
        );
    }

    const inputProps = props.inputProps
        ? {
              id: props.id,
              ...props.inputProps,
              className: cns(props.inputProps.className, css.input),
          }
        : {
              id: props.id,
              className: css.input,
          };
    return (
        <div {...containerProps}>
            <input {...inputProps} autoFocus />
            {props.icon}
        </div>
    );
};
